import React from 'react';
import Carousel from 'react-material-ui-carousel'
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

import './style.scss';

import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Paper,
  Button,
} from '@mui/material';

function InfoScreens({ data, onClick, onClose }) {
  const Banner = (props) => {

    let items = [];

    const item = props.item;

    const media = (
      <Grid item xs={12} key={item.Name}>
        <CardMedia
          className="Media"
          image={item.Image}
          title={item.Name}
        >
          <div className="overlay"></div>
          <CardContent className="Content2">
            <div className="center">
              <Typography className="Title">
                {props.item.Name}
              </Typography>

              <Typography className="Caption">
                {props.item.Description}
              </Typography>
              {item.ButtonText && (
                item.target ? (
                  <Button type="button" id="link-button" variant="outlined" className="ViewButton" component={Link}
                    href={props.item.href} target='_blank' rel='noreferrer'>
                    {props.item.ButtonText}
                  </Button>
                ) : (
                  <Link type="button" id="link-button" variant="outlined" className="ViewButton MuiButton" to={props.item.href}>{props.item.ButtonText}</Link>
                )
              )
              }
              {item.DismissButton &&
                <Button type="button" id="dismiss-button" variant="outlined" onClick={onClick} className="ViewButton">
                  {props.item.DismissButton}
                </Button>
              }
            </div>
          </CardContent>
        </CardMedia>
      </Grid>
    )

    items.push(media);

    return (
      <Card raised className="Banner">
        <Grid container spacing={0} className="BannerGrid">
          {items}
        </Grid>
      </Card>
    )
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        {onClick &&
          <Button type="button" id="dismiss-button" onClick={onClick} className="closeIcon">
            <CloseIcon />
          </Button>
        }
        <Carousel navButtonsAlwaysVisible={data.length > 1 ? true : false} navButtonsAlwaysInvisible={data.length > 1 ? false : true} indicators={false} sx={{ mb: 3 }}>
          {
            data.map((item, index) => {
              return <Banner item={item} key={index} contentPosition={item.contentPosition} />
            })
          }
        </Carousel>
      </div>
    </>
  )
}

export default InfoScreens;